<template>
  <div class="page-receive-course-container">
    <receive-form
      v-if="receiveState === 0"
      class="receive-form"
      :style="{ top: formOffsetTop + 'px' }"
      @received="handleReceived"
    ></receive-form>
    <succeed v-else-if="receiveState === 1"></succeed>
    <failed v-else-if="receiveState === 2"></failed>
  </div>
</template>

<style lang="scss" scoped>
.page-receive-course-container {
  position: relative;
}

.receive-form {
  position: absolute;
  margin: 48px;
  padding: 48px;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 15px 15px rgba($color: #000000, $alpha: 0.05),
    0px 5px 5px rgba($color: #8a8282, $alpha: 0.05);
}
</style>

<script>
// import cookie from 'js-cookie'
import ReceiveForm from './receive-form.vue'
import Succeed from '@/views/actouch/success.vue'
import Failed from '@/views/actouch/fail.vue'
// import { Toast } from 'vant'

const isIPhoneX = () => {
  if (typeof window !== 'undefined' && window) {
    return (
      /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812
    )
  }
  return false
}
console.log(isIPhoneX())

export default {
  components: {
    ReceiveForm,
    Succeed,
    Failed
  },
  data () {
    return {
      formOffsetTop:
        ((isIPhoneX() ? 530 : 420) * document.body.clientWidth) / 750,
      receiveState: 0
      // 0 - 未领取； 1 - 成功； 2 - 失败；
    }
  },
  methods: {
    handleReceived (result) {
      // this.receiveState = result ? 1 : 2
      // Toast('继续向左滑动，报名发布会')
      if (result === false) {
        this.receiveState = 2
        // Toast('继续向左滑动，报名发布会')
      }
    }
  }
}
</script>
